<script setup>
import InputMediaBankGallery from "../../../../forms/inputMediaBankGallery.vue";
import UiTabbed from "../../../../containers/uiTabbed.vue";

const props = defineProps({
    modelValue: {},
})

</script>

<template>
    <ui-tabbed
        v-if="modelValue.showInstructions"
        :track-state="false"
        class="mb-4"
    >
        <ui-tabbed-tab
            :title="_mft('form:field.instructions.text')"
            value="tab-more-info-text"
            :active="true"
        >
            <input-editor
                v-model:content="modelValue.metaText"
            />
        </ui-tabbed-tab>

        <ui-tabbed-tab
            :title="_mft('form:field.instructions.image')"
            value="tab-more-info-image"
        >
            <div v-if="modelValue.metaImage">
                <div class="flex justify-center">
                    <media-bank-entries-display
                        v-if="modelValue.metaImage"
                        :data-url="route('mediaBank.entries.show', modelValue.metaImage)"
                    />
                </div>
                <div class="flex justify-end mt-2">
                    <button-danger
                        size="sm"
                        @click="modelValue.metaImage = null"
                    >{{ _mft('shared:action.delete') }}</button-danger>
                </div>
            </div>
            <input-media-bank-gallery
                v-else
                type="image"
                v-model:content="modelValue.metaImage"
            />
        </ui-tabbed-tab>

        <ui-tabbed-tab
            :title="_mft('form:field.instructions.video')"
            value="tab-more-info-video"
        >
            <div v-if="modelValue.metaVideo">
                <div class="flex justify-center">
                    <media-bank-entries-display
                        v-if="modelValue.metaVideo"
                        :data-url="route('mediaBank.entries.show', modelValue.metaVideo)"
                    />
                </div>
                <div class="flex justify-end mt-2">
                    <button-danger
                        size="sm"
                        @click="modelValue.metaVideo = null"
                    >{{ _mft('shared:action.delete') }}</button-danger>
                </div>
            </div>
            <input-media-bank-gallery
                v-else
                type="video"
                v-model:content="modelValue.metaVideo"
            />
        </ui-tabbed-tab>
    </ui-tabbed>
</template>

<style scoped>

</style>
